// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--3lL_w";
export var hero_bg = "styles-module--hero_bg--2QQnA";
export var hero_inner = "styles-module--hero_inner--3X7Oe";
export var jsAnimInit = "styles-module--jsAnimInit--XFtIr";
export var hero_center = "styles-module--hero_center--pX0JU";
export var hero_top = "styles-module--hero_top--19Zai";
export var hero_title = "styles-module--hero_title--k16MZ";
export var hero_desc = "styles-module--hero_desc--HTW7i";